// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"aec093aa72868b3beb4d","678":"a8f592234233909004cf","883":"83d5afadfbeaebfeeb4e"}[chunkId] + ".js";
};